import Vue from 'vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from './router'
import store from './store'
import website from '@/config/website'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

window.axios = axios
Vue.use(VueAxios, axios)

Vue.use(ElementUI)

// 加载website
Vue.prototype.website = website;

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
